import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FileHandle } from 'src/app/shared/directives/drag-drop.directive';
import { Resolution } from 'src/app/shared/models/resolution.model';

@Injectable({
  providedIn: 'root'
})
export class ImageUploadService {

  private url: string;
  private key: string;

  constructor(private http: HttpClient, public router: Router) {
      this.url = environment.apiUrl;
      this.key = environment.apiKey;
  }

  /**
   *
   */
  public getAllStocks(): Observable<object> {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .get(`${this.url}/stocks`, {responseType: 'json', headers})
               .pipe(
                 catchError(this.errorHandler)
               );
  }

  /**
   *
   */
  public getAllPurposes(): Observable<object> {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .get(`${this.url}/purposes`, {responseType: 'json', headers})
               .pipe(
                 catchError(this.errorHandler)
               );
  }

  /**
   *
   */
  public getResolutions(stockId: string, purposeId: string): Observable<object> {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    const params = new HttpParams()
      .append('stockId'  , stockId)
      .append('purposeId', purposeId);

    return this.http
               .get(`${this.url}/resolutions/assign`, {responseType: 'json', headers, params})
               .pipe(
                 catchError(this.errorHandler)
               );
  }

  /**
   *
   * @param form
   * @param attachedFiles
   */
  public uploadImage(form: any, attachedFiles: FileHandle[]): Observable<object> {
    const headers = new HttpHeaders()
    .append('x-api-key', this.key);

    const formData = new FormData();
    formData.append('data', JSON.stringify(form));
    formData.append('file', attachedFiles[0].file);

    return this.http
             .post(`${this.url}/images`, formData, {responseType: 'json', headers})
             .pipe(
               catchError(this.errorHandler)
             );
  }

  /**
   *
   * @param error
   */
  private errorHandler(error: HttpErrorResponse) {
    console.log('Ha ocurrido un error al ejecutar el endpoint: ', error);
    return throwError(error.error);
  }
}
